import { Model } from '@/models/Model';

export class KlaviyoSyncRun extends Model {
  protected $name: string = 'KlaviyoSyncRun';
  protected $endpoint: string = '/klaviyo-sync-runs';
  protected $fillable: string[] = [];

  public id?: number;
  public domain?: string;
  public started_at?: string;
  public finished_at?: string;
  public rows_fetched?: number;
  public rows_inbound_only?: number;
  public rows_updated?: number;
  public rows_created?: number;
  public rows_failed?: number;
  public status?: string;
  public notes?: string;
  public errors_count?: number;
}
